module.exports = __webpack_public_path__ + "static/home-blog-hero.3d5fda26.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/home-blog-hero.jpg
// module id = 666
// module chunks = 0